// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SiteFooter_inner__1vXrJ {
  max-width: 1140px;
  margin: 0 auto;
  padding: 1.35rem 1.25rem 1.65rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-align: center;
}

.SiteFooter_socialRow__WnPDQ {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.SiteFooter_socialLink__K-hGU {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  transition: background-color 0.15s ease, transform 0.15s ease;
}

.SiteFooter_socialLink__K-hGU:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-1px);
}

.SiteFooter_socialLink__K-hGU img {
  width: 22px;
  height: 22px;
  display: block;
  object-fit: contain;
}

.SiteFooter_bottomRow__IDIXV {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.85rem;
  width: 100%;
}

.SiteFooter_copyright__ocodb {
  margin: 0;
  font-size: 0.75rem;
  line-height: 1.55;
  color: #b3b3b3;
  max-width: 36rem;
}

.SiteFooter_linkNav__IAlOh {
  width: 100%;
}

.SiteFooter_linkList__OGaOv {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.45rem 0.75rem;
  list-style: none;
  margin: 0;
  padding: 0;
  justify-items: center;
}

.SiteFooter_linkList__OGaOv a {
  font-size: 0.78rem;
  color: #c8c8c8;
  text-decoration: none;
  line-height: 1.45;
  padding: 0.2rem 0.15rem;
  transition: color 0.15s ease;
}

.SiteFooter_linkList__OGaOv a:hover {
  color: #ffffff;
  text-decoration: underline;
}

@media (min-width: 576px) {
  .SiteFooter_linkList__OGaOv {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.35rem 1.1rem;
  }
}

@media (min-width: 992px) {
  .SiteFooter_inner__1vXrJ {
    gap: 1.15rem;
    padding: 1.5rem 1.75rem 1.75rem;
  }

  .SiteFooter_bottomRow__IDIXV {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 1.25rem;
    text-align: left;
  }

  .SiteFooter_copyright__ocodb {
    flex: 1 1 280px;
    text-align: left;
    max-width: none;
  }

  .SiteFooter_linkNav__IAlOh {
    flex: 1 1 320px;
    width: auto;
  }

  .SiteFooter_linkList__OGaOv {
    justify-content: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/nav_bar/SiteFooter.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".inner {\n  max-width: 1140px;\n  margin: 0 auto;\n  padding: 1.35rem 1.25rem 1.65rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  text-align: center;\n}\n\n.socialRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.socialLink {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.06);\n  transition: background-color 0.15s ease, transform 0.15s ease;\n}\n\n.socialLink:hover {\n  background: rgba(255, 255, 255, 0.12);\n  transform: translateY(-1px);\n}\n\n.socialLink img {\n  width: 22px;\n  height: 22px;\n  display: block;\n  object-fit: contain;\n}\n\n.bottomRow {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.85rem;\n  width: 100%;\n}\n\n.copyright {\n  margin: 0;\n  font-size: 0.75rem;\n  line-height: 1.55;\n  color: #b3b3b3;\n  max-width: 36rem;\n}\n\n.linkNav {\n  width: 100%;\n}\n\n.linkList {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.45rem 0.75rem;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  justify-items: center;\n}\n\n.linkList a {\n  font-size: 0.78rem;\n  color: #c8c8c8;\n  text-decoration: none;\n  line-height: 1.45;\n  padding: 0.2rem 0.15rem;\n  transition: color 0.15s ease;\n}\n\n.linkList a:hover {\n  color: #ffffff;\n  text-decoration: underline;\n}\n\n@media (min-width: 576px) {\n  .linkList {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 0.35rem 1.1rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .inner {\n    gap: 1.15rem;\n    padding: 1.5rem 1.75rem 1.75rem;\n  }\n\n  .bottomRow {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1.25rem;\n    text-align: left;\n  }\n\n  .copyright {\n    flex: 1 1 280px;\n    text-align: left;\n    max-width: none;\n  }\n\n  .linkNav {\n    flex: 1 1 320px;\n    width: auto;\n  }\n\n  .linkList {\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inner": `SiteFooter_inner__1vXrJ`,
	"socialRow": `SiteFooter_socialRow__WnPDQ`,
	"socialLink": `SiteFooter_socialLink__K-hGU`,
	"bottomRow": `SiteFooter_bottomRow__IDIXV`,
	"copyright": `SiteFooter_copyright__ocodb`,
	"linkNav": `SiteFooter_linkNav__IAlOh`,
	"linkList": `SiteFooter_linkList__OGaOv`
};
export default ___CSS_LOADER_EXPORT___;
